import {useState} from 'react'
import {Flip, toast} from "react-toastify";

function useCopyToClipboard() {
    const [copiedText, setCopiedText] = useState(null)

    const copy = async text => {
        if (!navigator?.clipboard) {
            return false
        }

        try {
            await navigator.clipboard.writeText(text)
            setCopiedText(text)
            toast.success('Skopiowano do schowka', {
                autoClose: 1500,
                hideProgressBar: true,
                pauseOnHover: false,
                transition: Flip,
                closeOnClick: true,
            })
            return true
        } catch (error) {
            setCopiedText(null)
            return false
        }
    }

    return [copiedText, copy]
}

export default useCopyToClipboard